"use strict";

var _toConsumableArray = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Adornments = void 0;

var _react = _interopRequireDefault(require("react"));

var _icons = require("@creditas/icons");

var _propTypes = require("prop-types");

var _Adornment = require("./Adornment");

var _input = require("./input.style");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  adornments: _propTypes.array,
  select: _propTypes.bool,
  multiple: _propTypes.bool,
  success: _propTypes.bool,
  warning: _propTypes.bool,
  error: _propTypes.bool,
  loading: _propTypes.bool,
  search: _propTypes.bool,
  IconSelect: _propTypes.elementType,
  IconSuccess: _propTypes.elementType,
  IconWarning: _propTypes.elementType,
  IconError: _propTypes.elementType,
  IconLoader: _propTypes.elementType,
  IconSearch: _propTypes.elementType
} : {};
var defaultProps = {
  IconSelect: _icons.IconChevronDown,
  IconSuccess: _icons.IconCheck,
  IconWarning: _icons.IconAlertTriangle,
  IconError: _icons.IconAlertCircle,
  IconLoader: _icons.IconFileLoader,
  IconSearch: _icons.IconActionSearch,
  adornments: []
};

var Adornments = function Adornments(_ref) {
  var IconSelect = _ref.IconSelect,
      IconSuccess = _ref.IconSuccess,
      IconWarning = _ref.IconWarning,
      IconError = _ref.IconError,
      IconLoader = _ref.IconLoader,
      IconSearch = _ref.IconSearch,
      adornments = _ref.adornments,
      select = _ref.select,
      multiple = _ref.multiple,
      success = _ref.success,
      warning = _ref.warning,
      error = _ref.error,
      loading = _ref.loading,
      search = _ref.search;
  var newAdornments = [].concat(_toConsumableArray(adornments), [select && !multiple && (0, _core.jsx)(IconSelect, {
    key: "iconSelect",
    css: _input.inputIconComponent
  }), search && (0, _core.jsx)(IconSearch, {
    key: "iconSearch",
    css: _input.inputIconComponent
  }), success && (0, _core.jsx)(IconSuccess, {
    key: "iconSuccess",
    css: _input.inputIconComponent
  }), warning && (0, _core.jsx)(IconWarning, {
    key: "iconWarning",
    css: _input.inputIconComponent
  }), error && (0, _core.jsx)(IconError, {
    key: "iconError",
    css: _input.inputIconComponent
  }), loading && (0, _core.jsx)(IconLoader, {
    key: "iconLoader",
    css: _input.inputIconComponent
  })]).filter(Boolean);
  return (0, _core.jsx)(_Adornment.Adornment, {
    position: "end"
  }, newAdornments);
};

exports.Adornments = Adornments;
process.env.NODE_ENV !== "production" ? Adornments.propTypes = propTypes : void 0;
Adornments.defaultProps = defaultProps;